import { User } from 'api';
import { UserType } from './types';

export const isIssuer = (user: User | null | undefined) => user && !user?.investor;

export const isInvestor = (user: User | null | undefined) => !!user?.investor;

export const getUserType = (user: User) =>
  isIssuer(user) ? UserType.Issuer : isInvestor(user) ? UserType.Investor : UserType.Default;
